module.exports = __webpack_public_path__ + "static/media/cover-button.e322c979.png";